import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

import { getLastServiceDate } from '../../utils';

const propTypes = {
  lastDate: PropTypes.string.isRequired,
  totalCostIncTax: PropTypes.number.isRequired,
  monthlyPayments: PropTypes.number.isRequired,
  monthlyPaymentsCount: PropTypes.number.isRequired,
};

const PaymentDetails = ({
  lastDate,
  totalCostIncTax,
  monthlyPayments,
  monthlyPaymentsCount,
}) => (
  <Fragment>
    <b>Payment plan</b>
    <div>
      Initial payment&nbsp;
      <b>
        &pound;
        {0}
      </b>
      <div>
        <b>{monthlyPaymentsCount}</b>
        &nbsp; monthly payments of&nbsp;
        <b>
          &pound;
          {monthlyPayments.toFixed(2)}
        </b>
        &nbsp; until {lastDate}
      </div>
      <div>
        Total&nbsp;
        <b>
          &pound;
          {totalCostIncTax.toFixed(2)}
        </b>
        &nbsp; inc VAT
      </div>
    </div>
  </Fragment>
);

PaymentDetails.propTypes = propTypes;

const mapStateToProps = ({ quote: { quoteDetails } }) => {
  const {
    Components,
    paymentSumPerMonth,
    paymentMonths,
    paymentCustomerPrice,
  } = quoteDetails;

  const lastServiceDate = getLastServiceDate(Components);

  return {
    totalCostIncTax: +paymentCustomerPrice || 0,
    lastDate: moment(lastServiceDate)
      .subtract(2, 'month')
      .format('MMMM YYYY'),
    monthlyPaymentsCount: paymentMonths,
    monthlyPayments: paymentSumPerMonth,
  };
};

export default connect(mapStateToProps)(PaymentDetails);
